import React from "react";
import "./card_custom.css"
import { Button, Card, CardBody, CardGroup, CardText, Container, Row } from "reactstrap";

export function CardCustom(props) {
  return (
    <Card className="card-custom">
        <Row className="py-2">
          <span 
            className="material-symbols-outlined"   
            style={{
              fontVariationSettings: "'FILL' 0, 'wght' 700, 'GRAD' 0, 'opsz' 24",
              fontSize: "32px",
              color: "#5AE94D",
            }}>
            check
          </span> 
        </Row>        
        <CardText>                   
          {props.text}
        </CardText>
    </Card> 
  );
}

export function CardCustom2(props) {
  return (
    <>
      <h4 className="card-title">{props.title}</h4>
      <p>{props.text}</p>    
      <ol>
        {props.list && props.list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ol>       
    </>
  );
}